import Reveal from "./Reveal";

// Standard inner-page hero with optional image on the right.
export const PageHero = ({ overline, title, subtitle, image, imageAlt, children }) => (
  <section className="relative overflow-hidden border-b border-slate-100">
    <div className="absolute -top-40 right-0 w-[600px] h-[600px] soft-orb" />
    <div className={`max-w-7xl mx-auto px-4 md:px-8 pt-14 md:pt-20 pb-12 md:pb-16 relative ${image ? "grid lg:grid-cols-2 gap-12 items-center" : ""}`}>
      <Reveal>
        <span className="text-xs font-bold tracking-[0.22em] uppercase text-royal mb-5 block">{overline}</span>
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-navy-900 leading-[1.0]">
          {title}
        </h1>
        {subtitle && <p className="mt-6 text-lg text-slate-500 leading-relaxed max-w-xl">{subtitle}</p>}
        {children}
      </Reveal>
      {image && (
        <Reveal delay={0.15}>
          <img src={image} alt={imageAlt} className="rounded-3xl w-full object-cover shadow-xl" />
        </Reveal>
      )}
    </div>
  </section>
);

export default PageHero;
